import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import moment from 'moment';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css'; // For some basic styling. (OPTIONAL)
// @mui
import { Box, ButtonBase, Dialog, DialogTitle, Typography, Stack, styled } from '@mui/material';
import Iconify from './Iconify';
import useLocales from '../hooks/useLocales';
import { ThemeButton } from '../layouts/GlobalStyles';

// ----------------------------------------------------------------------

CustomDateRangePicker.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setDateRange: PropTypes.func,
  dateRange: PropTypes.object,
  inputProps: PropTypes.object,
};

// ----------------------------------------------------------------------

export default function CustomDateRangePicker({ open, setOpen, setDateRange, dateRange, inputProps }) {
  const { translate } = useLocales();

  const [customDateRange, setCustomDateRange] = useState(null);

  const onSelect = (dates) => {
    console.log(`dates = ${JSON.stringify(dates)}`);
    setCustomDateRange(dates);
  };

  const handleConfirm = () => {
    console.log(`customDateRange = ${JSON.stringify(customDateRange)}`);
    setDateRange({ ...customDateRange });
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => {
        setCustomDateRange(null);
        setOpen(false);
      }}
      PaperProps={{
        sx: {
          background: '#003C79',
          width: 'auto',
          p: 1.5,
          borderRadius: '5px !important',
          alignItems: 'center',
          border: '1px solid #FFEDA3',
          margin: 0,
        },
      }}
    >
      <DialogTitle>{translate('choose_date')}</DialogTitle>

      <Iconify
        icon={'iconamoon:close-light'}
        sx={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer' }}
        width={35}
        height={35}
        onClick={() => {
          setCustomDateRange(null);
          setOpen(false);
        }}
      />

      <Box sx={{ background: '#003C79', px: 1, mb: 2 }}>
        <DateRangePicker
          onSelect={onSelect}
          singleDateRange={true}
          numberOfCalendars={1}
          selectionType="range"
          value={customDateRange}
          className="custom-daterange"
        />
      </Box>

      <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>
        <ThemeButton onClick={() => setOpen(false)} sx={{ flex: 1, height: '36px', width: '100%' }}>
          {translate('cancel')}
        </ThemeButton>
        <ThemeButton onClick={() => handleConfirm()} sx={{ flex: 1, height: '36px', width: '100%' }}>
          {translate('confirm')}
        </ThemeButton>
      </Stack>
    </Dialog>
  );
}
